<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('teaching_staff')">
                    <div class="label-as-input">
                        {{ isNotNullValue(formData.instructor_name) + " " + isNotNullValue(formData.instructor_surname) }}
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('semester')">
                    <div class="label-as-input">
                        {{
                            formData.semester
                                ? formData.academic_year +
                                  " / " +
                                  formData.semester
                                : "-"
                        }}
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('amount')">
                    <div class="label-as-input">
                        {{ isNotNullValue(formData.amount) }}
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('comments')">
                    <div class="label-as-input">
                        {{ isNotNullValue(formData.explanation) }}
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components

// Services
import AdjunctPaymentService from "@/services/AdjunctPaymentService";

// Other

export default {
    props: {
        formId: {
            type: Number,
        },
    },
    data() {
        return {
            formData: {},
            formLoading: false,
        };
    },

     created() {
        this.get(this.formId);
    },
    methods: {
        get(id) {
            AdjunctPaymentService.get(id)
                .then((response) => {
                    this.formData = response.data.data;
                })
                .catch((e) => {
                    this.showErrors(e);
                });
        },
    },
};
</script>
